import { useEffect, useState, Fragment } from 'react'
import { Typography, Button, IconButton, Box, CircularProgress, Divider } from '@material-ui/core'
import { ArrowBack as BackIcon, Bookmark as BookmarkedIcon, BookmarkBorder as BookmarkIcon, PlayArrow as PlayIcon } from '@material-ui/icons'
import { useParams, useHistory } from 'react-router-dom'
import axios from 'axios'



const Definition = ({ addToBookmarks, removeFromBookmarks, bookmarks }) => {
    const { word } = useParams();
    const history = useHistory();
    const [words, setWords] = useState([])
    const [exist, setExist] = useState(true);
    const [audio, setAudio] = useState(null)

    const isBookmarked = Object.keys(bookmarks).includes(word);

    const updateState = data => {
        setWords(data)
        if (!data[0].phonetics.length) return
        const url = data[0].phonetics[0].audio
        const aUrl = url.includes('https') ? url : url.replace('//ssl', 'https://ssl')
        setAudio(new Audio(aUrl))
    }

    useEffect(() => {
        const fetchDef = async () => {
            console.log('fetching')
            try {
                const resp = await axios.get(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`)
                if (!resp.data.length) return setExist(false);
                updateState(resp.data)
            } catch (err) {
                setExist(false)
            }

        }
        if (isBookmarked) updateState(bookmarks[word])
        else fetchDef()
    }, [])

    if (!exist) {
        return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '100vh' }}>
            <Typography>Word not found</Typography>
            <Button onClick={history.goBack} sx={{ textTransform: 'capitalize', mt: 2 }} variant="contained">Go back</Button>
        </Box>
    }

    if (!words.length) {
        return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '100vh' }}>
            <CircularProgress />
        </Box>
    }
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <IconButton onClick={history.goBack} size="small">
                    <BackIcon sx={{ color: 'black' }} />
                </IconButton>
                <IconButton onClick={() => isBookmarked ? removeFromBookmarks(word) : addToBookmarks(word, words)} size="small">
                    {isBookmarked ? <BookmarkedIcon sx={{ color: 'black' }} /> : <BookmarkIcon sx={{ color: 'black' }} />}
                </IconButton>
            </Box>
            <Box sx={{
                mt: 3,
                background: 'linear-gradient(90.17deg, #191E5D 0.14%, #0F133A 98.58%)',
                boxShadow: '0px 10px 20px rgba(19, 23, 71, 0.25)',
                px: 4,
                py: 5,
                color: 'white',
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <Typography className="capitalize" variant="h5">{word}</Typography>
                {audio && <IconButton onClick={() => audio.play()} variant="funky" sx={{ p: 1, boxShadow: 'none' }}>
                    <PlayIcon /></IconButton>}
            </Box>
            {
                words.map((word, idx) =>
                    <Fragment key={idx}>
                        <Divider sx={{ display: idx !== 0 ? 'block' : 'none', my: 3 }} />
                        {word.meanings.map(meaning => <Box

                            sx={{
                                boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.05)',
                                backgroundColor: '#fff',
                                p: 2,
                                borderRadius: 2,
                                mt: 3
                            }}>
                            <Typography className="capitalize" color="GrayText" variant="subtitle1">{meaning.partOfSpeech}</Typography>
                            {meaning.definitions.map((def, idx) =>
                                <Typography key={def.definition} className="capitalize" sx={{ my: 1 }} color="GrayText" variant="body2">{meaning.definitions.length > 1 ? `${idx + 1}.` : ''} {def.definition}</Typography>
                            )}
                        </Box>
                        )}
                    </Fragment>
                )
            }
        </>
    )
}

export default Definition
